import { IRoute } from 'vev';
import { useGlobalStore } from './use-store';

/**
 * `useRoute` watches and returns for changes to the current route
 */
export function useRoute(): IRoute {
  return useGlobalStore((state) => state.route, []);
}
